import { render, staticRenderFns } from "./CollectWriteModalLayout.vue?vue&type=template&id=390a141a&scoped=true&"
import script from "./CollectWriteModalLayout.vue?vue&type=script&lang=js&"
export * from "./CollectWriteModalLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390a141a",
  null
  
)

export default component.exports